import Request from "services";
import { Endpoints } from "services/endpoints";
import { handleRequestError } from "utils";
import { CreateMerchantAccount, CreateWebhookAndCallBackUrlRequest, CreateWebhookAndCallBackUrlResponseData, GetMerchantAccountResponseData, MerchantContactRequest, SetApiKeyRequest, SetApiKeyResponseData, SetIpWhiteListRequest, UpdateMerchantPreferenceRequest } from "./types";
import { Merchant, MerchantBankAccount, MerchantContact } from "interface/merchant";
import { Domain } from "interface/User";

export const updateMerchantContacts = async (data: MerchantContactRequest) => {
    try {
        const response = await Request.putWithUserToken<MerchantContact>(Endpoints.merchantContacts, {data});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}

export const updateMerchantPreference = async (data: UpdateMerchantPreferenceRequest) => {
    try {
        const response = await Request.putWithUserToken<Merchant>(Endpoints.updateMerchantPreference, {data});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}

export const updateDomain = async (domain: Domain) => {
    try {
        const response = await Request.putWithUserToken<Merchant>(Endpoints.updateDomain, {data: {
            domain,  
        }});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}

export const setApiKey = async (data: SetApiKeyRequest) => {
    try {
        const response = await Request.postWithUserToken<SetApiKeyResponseData>(Endpoints.setApiKey, {data});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
};

export const generateApiKey = async (domain: Domain) => {
    try {
        const response = await Request.getWithUserToken<string>(Endpoints.generateApiKey, {params: {domain}});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
};

export const setIpWhiteList = async (data: SetIpWhiteListRequest) => {
    try {
        const response = await Request.putWithUserToken<Merchant>(Endpoints.setIpWhiteList, {data: data});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
};

export const createMerchantAccount = async (data: CreateMerchantAccount) => {
    try {
        const response = await Request.postWithUserToken<MerchantBankAccount>(Endpoints.createMerchantAccount, {data: data});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
};

export const getMerchantAccounts = async () => {
    try {
        const response = await Request.getWithUserToken<GetMerchantAccountResponseData>(Endpoints.merchantAccounts,);
        return response;
    } catch (error) {
        handleRequestError(error)
    }
};

export const updateMerchantAccount = async (id: string, type: 'PRIMARY' | 'SECONDARY') => {
    try {
        const response = await Request.putWithUserToken<MerchantBankAccount>(Endpoints.updateMerchantAccountType(id), {params: {type}});
        return response;
    } catch (error) {
        handleRequestError(error);
    }
};

export const deleteMerchantAccount = async (id: string) => {
    try {
        const response = await Request.deleteWithUserToken(Endpoints.merchantAccount(id));
        return response;
    } catch (error) {
        handleRequestError(error);
    }
};

export const createWebhookAndCallBackUrl = async (data: CreateWebhookAndCallBackUrlRequest) => {
    try {
        const response = await Request.postWithUserToken<CreateWebhookAndCallBackUrlResponseData>(Endpoints.createWebhookAndCallBackUrl, {data});
        return response;
    } catch (error) {
        handleRequestError(error);
    }
}

export const getWebhookAndCallBackUrl = async () => {
    try {
        const response = await Request.getWithUserToken<CreateWebhookAndCallBackUrlResponseData>(Endpoints.getWebhookAndCallBackUrl);
        return response;
    } catch (error) {
        handleRequestError(error);
    }
}